import React from 'react'
import {MdKeyboardArrowDown, MdKeyboardArrowUp, MdShoppingBasket} from 'react-icons/md'
import ClickOutside from '@components/ClickOutside'
import sleep from '@helpers/misc/sleep'
import FormatNumber from '@i18n/formatNumber/Component'
import Container from '@packages/justo-parts/lib/components/Container'
import {TFunction, withTranslation} from 'next-i18next'

import styles from './styles.module.css'

export interface CartMenuProps {
  open: boolean
  onClick: Function
  openOptions: boolean
  setOpenOptions: Function
  cart: any
  children: React.ReactNode
  options: React.ReactNode
  optionsLabel: React.ReactNode
  forceOpenOptions: boolean
  t: TFunction
}

export class CartMenu extends React.Component<CartMenuProps> {
  state = {className: '', showMessage: 'close'}

  componentDidMount() {
    const {cart} = this.props
    const total = (cart && cart.totalPrice) || 0
    if (total) {
      this.showMessage()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {cart} = this.props
    const {cart: prevCart} = prevProps
    if (!prevCart) return // First load, skip animation

    const total = (cart && cart.totalPrice) || 0
    const prevTotal = (prevCart && prevCart.totalPrice) || 0
    if (total > prevTotal) {
      this.attention()
    }

    if (!prevTotal && total) {
      this.showMessage()
    }
  }

  async attention() {
    this.setState({className: 'animated shake'})
    await sleep(1000)
    this.setState({className: 'animated'})
  }

  async showMessage() {
    this.setState({showMessage: 'show'})
    await sleep(3000)
    this.setState({showMessage: 'hide'})
    await sleep(1000)
    this.setState({showMessage: 'close'})
  }

  render() {
    const {open, onClick, cart, setOpenOptions, openOptions, optionsLabel} = this.props
    const total = (cart && cart.itemsPrice) || 0

    const openClassName = total > 0 ? styles.cartHightlightMobile : ''

    return (
      <div className={openClassName + ' ' + styles.container}>
        <Container>
          <div className={styles.inner}>
            <div
              className={cart ? styles.addressCallToAction : styles.addressCallToActionLoading}
              // @ts-expect-error ts-migrate(2322) FIXME: Type 'Function' is not assignable to type 'MouseEv... Remove this comment to see the full error message
              onClick={openOptions ? null : setOpenOptions}>
              <div className={styles.title}>{optionsLabel}</div>
              <div className={styles.icon}>
                {openOptions ? <MdKeyboardArrowUp size={22} /> : <MdKeyboardArrowDown size={22} />}
              </div>
            </div>
            {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'Function' is not assignable to type 'MouseEv... Remove this comment to see the full error message */}
            <div className={styles.divider} onClick={open ? null : onClick} />
            {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'Function' is not assignable to type 'MouseEv... Remove this comment to see the full error message */}
            <div className={styles.button} onClick={open ? null : onClick}>
              <div className={styles.total + ' ' + this.state.className}>
                {cart ? <FormatNumber value={total} /> : ''}
              </div>
              <div className={styles.icon}>
                <MdShoppingBasket size={22} style={{marginRight: 5}} aria-label="cart" />
              </div>
            </div>
          </div>
        </Container>
        {this.state.showMessage !== 'close' ? (
          <Container>
            <div className={styles.childrenContainer}>
              <div
                className={this.state.showMessage === 'show' ? styles.message : styles.messageHide}>
                <div className={styles.arrowWrapper}>
                  <div className={styles.arrowUp} />
                </div>
                {this.props.t('order.titleOrderContinue')}
              </div>
            </div>
          </Container>
        ) : null}
        {openOptions ? (
          <Container>
            <ClickOutside onClickOutside={() => setOpenOptions()} avoidElementName="modal-root">
              <div className={styles.childrenContainer}>{this.props.options}</div>
            </ClickOutside>
          </Container>
        ) : null}
        {open ? (
          <Container>
            <ClickOutside onClickOutside={() => onClick()} avoidElementName="modal-root">
              <div className={styles.childrenContainer}>{this.props.children}</div>
            </ClickOutside>
          </Container>
        ) : null}
      </div>
    )
  }
}
export default withTranslation()(CartMenu)
